import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";

function MyEarnings() {
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [upiId, setUpiId] = useState("");
  const [processing, setProcessing] = useState(false);

  const token = localStorage.getItem("token");

  const fetchWallet = async () => {
    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/wallet", {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) setWallet(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWallet();
  }, []);

  const handleWithdraw = async () => {
    if (!upiId.includes("@")) return alert("Please enter a valid UPI ID!");
    
    setProcessing(true);
    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/wallet/withdraw", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ amount: wallet.availableBalance, upiId })
      });
      const data = await res.json();
      
      if (data.success) {
        alert("✅ Request sent successfully! Admin will process it soon.");
        setShowModal(false);
        fetchWallet(); // Refresh balance
      } else {
        alert(data.message);
      }
    } catch (err) {
      alert("Error processing request");
    } finally {
      setProcessing(false);
    }
  };

  if (loading) return <><Navbar /><div className="text-center mt-5"><div className="spinner-border text-success" /></div></>;

  return (
    <>
      <Navbar />
      <div className="container mt-4 mb-5" style={{ maxWidth: "600px" }}>
        <h3 className="fw-bold text-dark mb-4">💰 My Earnings</h3>

        {/* 🟢 MAIN BALANCE CARD (Light Green Theme) */}
        <div className="card border-0 shadow-lg mb-4" style={{ background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)", borderRadius: "16px" }}>
          <div className="card-body p-4 text-white">
            <p className="mb-1 opacity-75 fw-semibold">Available Balance</p>
            <h1 className="display-4 fw-bold mb-3">₹{wallet?.availableBalance || 0}</h1>
            
            <button 
              className="btn btn-light text-success fw-bold px-4 py-2 rounded-pill shadow-sm"
              onClick={() => setShowModal(true)}
              disabled={wallet?.availableBalance <= 0}
            >
              💸 Withdraw Funds
            </button>
          </div>
        </div>

        {/* ⚪ STATS ROW */}
        <div className="row g-3 mb-4">
          <div className="col-6">
            <div className="card border-0 shadow-sm bg-white rounded-4 h-100 p-3 border-start border-success border-4">
              <small className="text-muted fw-bold">Total Earned</small>
              <h4 className="fw-bold text-dark mt-1 mb-0">₹{wallet?.totalEarned || 0}</h4>
            </div>
          </div>
          <div className="col-6">
            <div className="card border-0 shadow-sm bg-white rounded-4 h-100 p-3 border-start border-warning border-4">
              <small className="text-muted fw-bold">Pending Payout</small>
              <h4 className="fw-bold text-dark mt-1 mb-0">₹{wallet?.pendingWithdrawal || 0}</h4>
            </div>
          </div>
        </div>

        {/* 📜 TRANSACTION HISTORY */}
        <h5 className="fw-bold mb-3">Recent Transactions</h5>
        <div className="card border-0 shadow-sm bg-white rounded-4 overflow-hidden">
          {wallet?.withdrawals?.length === 0 ? (
            <div className="p-4 text-center text-muted">No withdrawals yet.</div>
          ) : (
            <ul className="list-group list-group-flush">
              {wallet?.withdrawals?.map((w, idx) => (
                <li key={idx} className="list-group-item d-flex justify-content-between align-items-center p-3">
                  <div>
                    <strong className="d-block text-dark">Withdrawal</strong>
                    <small className="text-muted">UPI: {w.upiId}</small>
                  </div>
                  <div className="text-end">
                    <strong className="d-block text-dark">- ₹{w.amount}</strong>
                    <span className={`badge ${w.status === "completed" ? "bg-success" : w.status === "rejected" ? "bg-danger" : "bg-warning text-dark"} rounded-pill`}>
                      {w.status.toUpperCase()}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* 💳 WITHDRAWAL MODAL */}
      {showModal && (
        <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.6)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-0 bg-success text-white rounded-top-4">
                <h5 className="modal-title fw-bold">Withdraw to Bank</h5>
                <button className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body p-4 text-center">
                <h3 className="fw-bold text-success mb-4">₹{wallet?.availableBalance}</h3>
                
                <div className="form-floating mb-3 text-start">
                  <input 
                    type="text" 
                    className="form-control border-success border-2" 
                    id="upiInput" 
                    placeholder="Enter UPI ID"
                    value={upiId}
                    onChange={(e) => setUpiId(e.target.value)}
                  />
                  <label htmlFor="upiInput" className="text-muted">Enter active UPI ID (e.g. name@ybl)</label>
                </div>
                
                <button 
                  className="btn btn-success w-100 py-3 fw-bold fs-6 rounded-3" 
                  onClick={handleWithdraw}
                  disabled={processing || !upiId}
                >
                  {processing ? "Submitting..." : "Confirm Withdrawal"}
                </button>
                <small className="text-muted d-block mt-3">Admin will verify and transfer within 24 hours.</small>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MyEarnings;